<template>
  <div class="AdminApprovalLevelInfo">
    <admin-approval-level-search-panel @search="search" />
    <box class="mt-2" :title="$t('pageList')">
      <div v-if="list.length > 0" class="pb-1">
        <v-data-table
          dense
          :disable-sort="true"
          :headers="headers"
          :items="list"
          :item-class="row_classes"
          hide-default-footer
          disable-pagination
        />
        <div class="attention">
          <v-alert
            class="ma-2"
            dense
            border="left"
            colored-border
            color="red"
            elevation="2"
            dismissible
            icon="mdi-alert-circle-outline"
          >
            <div class="text-small">
              توجه : سطر های قرمز رنگ انواع برگه هایی را نشان می دهد که سطح
              تایید مدیر برای آنها تعریف نشده است.
            </div>
          </v-alert>
        </div>
      </div>
      <div v-else>
        <empty-list />
      </div>
    </box>
  </div>
</template>

<script>
import AdminApprovalLevelSearchPanel from "../../components/requestManagement/AdminApprovalLevelSearchPanel.vue";
import Box from "../../components/widget/Box.vue";
import EmptyList from "../../components/widget/EmptyList.vue";
import ResultType from "../../model/ResultType";
export default {
  components: { AdminApprovalLevelSearchPanel, Box, EmptyList },
  data() {
    return {
      list: [],
      headers: [
        {
          text: this.$t("CodeName"),
          value: "CodeName",
        },
        {
          text: this.$t("approveLevel"),
          value: "StatusType",
        },
      ],
    };
  },
  methods: {
    row_classes(item) {
      if (item.StatusType == "") {
        return "bg-red"; //can also return multiple classes e.g ["orange","disabled"]
      }
    },
    search(searchParams) {
      var params = searchParams;
      this.$store
        .dispatch("sections/GetAdminSectionDegree", { params })
        .then((result) => {
          //console.log(result);
          if (result.type === ResultType.success) {
            this.list = result.data.Table;
          }
        });
    },
  },
};
</script>

<style>
</style>